var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2412 22.6058C15.9268 22.6058 16.4124 22.0513 16.7646 21.1927L23.0012 5.88994C23.1726 5.47853 23.2678 5.11183 23.2678 4.80775C23.2678 4.2264 22.887 3.86865 22.2681 3.86865C21.9443 3.86865 21.554 3.95809 21.116 4.11908L4.73901 10.013C3.93921 10.2992 3.32031 10.7553 3.32031 11.4082C3.32031 12.2311 3.98682 12.5083 4.90088 12.7677L10.0425 14.2344C10.6519 14.4133 10.9851 14.3954 11.4041 14.0377L21.8396 4.87035C21.9634 4.76303 22.1062 4.78091 22.2109 4.86141C22.3062 4.95085 22.3157 5.085 22.2014 5.20127L12.4705 15.0483C12.1086 15.415 12.0801 15.7191 12.261 16.3183L13.7749 21.0406C14.0605 21.944 14.3557 22.6058 15.2412 22.6058Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.f34fe5f07bcd600465071dbec684bcfa.svg";
export { ForwardRef as ReactComponent };